import React from "react";

const NoPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-indigo-500 text-white p-4">
      <div className="max-w-md w-full text-center">
        <div className="flex justify-center mb-4">
          <div className="w-32 h-32 bg-white rounded-full flex items-center justify-center shadow-lg">
            <svg
              className="w-16 h-16 text-indigo-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 16h-1v-4h-1m0-4h.01M12 17h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              ></path>
            </svg>
          </div>
        </div>
        <h1 className="text-4xl font-bold mb-4">403 No Page Found</h1>
        <p className="text-lg mb-6">Sorry, the page you are looking for does not exist.</p>
        <button
          className="bg-white text-indigo-500 font-semibold py-2 px-4 rounded shadow hover:bg-gray-200 transition duration-300 transform hover:scale-105"
          onClick={() => window.history.back()}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default NoPage;
